import { render, staticRenderFns } from "./preview-text.vue?vue&type=template&id=58345681&"
import script from "./preview-text.vue?vue&type=script&lang=js&"
export * from "./preview-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports